import { InputHTMLAttributes } from 'react';
import clsx from 'clsx';
import { Spinner } from 'mode-shared/components/Spinner';

type InputProps = {
  className?: string;
  loading?: boolean;
  size?: 'sm' | 'md' | 'lg';
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'size'>;

export const Input = ({ className, loading, size = 'md', ...props }: InputProps) => {
  return (
    <div className="relative">
      <input
        disabled={props.disabled || loading}
        className={clsx(
          'placeholder:text-neutral-500 px-4 w-full max-w-[200px] bg-grey-800 text-neutral-300 border border-grey-900 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary',
          (props.disabled || loading) && 'opacity-50',
          size === 'sm' && 'py-1.5 h-8',
          size === 'md' && 'py-2 h-10',
          size === 'lg' && 'py-2.5 h-12',
          className
        )}
        {...props}
      />
      {loading && <Spinner size={20} className="absolute right-2 top-1/2 -translate-y-1/2" />}
    </div>
  );
};
